var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19.7148C17.5 20.8958 16.6096 21.7863 15.4286 21.7863C14.2476 21.7863 13.3571 20.8958 13.3571 19.7148C13.3571 18.5338 14.2476 17.6434 15.4286 17.6434C16.6096 17.6434 17.5 18.5338 17.5 19.7148ZM6.5 19.7148C6.5 18.5338 7.39043 17.6434 8.57143 17.6434C9.75243 17.6434 10.6429 18.5338 10.6429 19.7148C10.6429 20.8958 9.75243 21.7863 8.57143 21.7863C7.39043 21.7863 6.5 20.8958 6.5 19.7148ZM13.3571 12.0006C13.3571 10.8196 14.2476 9.92913 15.4286 9.92913C16.6096 9.92913 17.5 10.8196 17.5 12.0006C17.5 13.1816 16.6096 14.072 15.4286 14.072C14.2476 14.072 13.3571 13.1816 13.3571 12.0006ZM6.5 12.0006C6.5 10.8196 7.39043 9.92913 8.57143 9.92913C9.75243 9.92913 10.6429 10.8196 10.6429 12.0006C10.6429 13.1816 9.75243 14.072 8.57143 14.072C7.39043 14.072 6.5 13.1816 6.5 12.0006ZM17.5 4.28627C17.5 5.46727 16.6096 6.3577 15.4286 6.3577C14.2476 6.3577 13.3571 5.46727 13.3571 4.28627C13.3571 3.10527 14.2476 2.21484 15.4286 2.21484C16.6096 2.21484 17.5 3.10527 17.5 4.28627ZM6.5 4.28627C6.5 3.10527 7.39043 2.21484 8.57143 2.21484C9.75243 2.21484 10.6429 3.10527 10.6429 4.28627C10.6429 5.46727 9.75243 6.3577 8.57143 6.3577C7.39043 6.3577 6.5 5.46727 6.5 4.28627Z",
    fill: "black",
    stroke: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.fc298d53fd7c0c263f26da30c845d72e.svg";
export { ForwardRef as ReactComponent };